module.exports = __webpack_public_path__ + "static/media/Picture 2.8aa5aeca.jpg";